// Module
var code = "<div ng-if=\"event\"><react-component name=\"CancelEvent\" props=\"{\nevent: event\n}\"></react-component></div>\n";
// Exports
module.exports = code;